<script>
import { createEventDispatcher, onMount, onDestroy } from 'svelte'
import { crossfade, fade } from 'svelte/transition'
import { cubicInOut } from 'svelte/easing'
import { flip } from 'svelte/animate'

import CircularVideo from './CircularVideo.svelte'  //  <-- this smells

const dispatch = createEventDispatcher()

export let deck, transitionApprovedToIndex, kill = false

let transitionDuration = 250/2 //ms

// let remainingSlides, viewedSlides
$: remainingSlides = [...deck.slides]
 
let viewedSlides = []

let activeSlideIndex = 0 // might want to replace with an 'active' prop on slide object

onMount( () => {
  dispatch('deckStarted')
})

onDestroy( () =>{
  // console.log("deck bye")
})

let requestSlideTransition = function(slideId, forward){
  userDidRequestOtherSlide = true
  if(forward == null || forward === undefined){ forward = true } // default is advancing by one slide
  
  dispatch("transitionRequested", { slideId: slideId, fromSlideIndex: activeSlideIndex, directionForward: forward})
}

let userDidRequestOtherSlide = false

$: { 
  if(!transitionApprovedToIndex == 0){ // this reactive block will fire on mount when the initial bound value is set, we should ignore that occasion
    userDidRequestOtherSlide = false
    if(transitionApprovedToIndex > deck.slides.length - 1){
      dispatch('deckEndReached')
    } else if(transitionApprovedToIndex > 0 && transitionApprovedToIndex <= deck.slides.length){
      viewedSlides.push(remainingSlides.shift())
      viewedSlides = viewedSlides
      remainingSlides = remainingSlides
      activeSlideIndex++
    } else if(transitionApprovedToIndex == -1){
      // move back one slide
      if(activeSlideIndex > 0){
        remainingSlides.unshift(viewedSlides[viewedSlides.length-1])
        remainingSlides = remainingSlides
        activeSlideIndex--
      } 
    }
  }
}

function fadeIn(node, { from, to }, params) {
  let d = params.duration
  return {
    delay: 100,
    duration: Math.sqrt(d) * 120,
    easing: cubicInOut,
    css: (t, u) =>
      `opacity: ${t};`
  };
}

// work in progress... probably need a slide component at thi spoint
// function circularWipeIn(node, { from, to }, params) {
//   let d = params.duration
//   return {
//     delay: 0,
//     duration: Math.sqrt(d) * 120,
//     easing: cubicInOut,
//     css: (t, u) =>
//       `transform: scale(${t});`
//   };
// }
</script>

<div class="deck" transition:fade={{ duration: transitionDuration, easing: cubicInOut }}>
  <div class="slides">
    {#each remainingSlides as slide, index(slide.id)}
      <div class="slide { slide.slideClass ? slide.slideClass : "" }" id="{slide.id}" out:fade={{ duration: transitionDuration, easing: cubicInOut}} animate:fadeIn={{duration: transitionDuration}}>
        <!-- {#if !userDidRequestOtherSlide} -->
          {#if slide.contentPOV == "object" || slide.contentPOV == 'first-person'}
            <div class="{"slide-content pov-" + slide.contentPOV }">
              {@html slide.content}
            </div>
          {:else if slide.contentPOV == "video-instructional"}
            <CircularVideo srcs={[
              { width: 360, src: slide.contentSrc.replace(".mp4", "-360.mp4") }, 
              { width: 300, src: slide.contentSrc.replace(".mp4", "-300.mp4")}
            ]} captionSrc={slide.contentTextTrack} playing={ index == 0 } on:videoEnded={ e => requestSlideTransition(slide.id)} continueAnimationCallbacks={!kill}
            />
          {:else}
            <video class="fullscreen-video" src={slide.contentSrc} controls preload on:ended={ e => { requestSlideTransition(slide.id)}} crossorigin="anonymous">
            {#if slide.captionSrc !== undefined}
              <track label="English" kind="captions" srclang="en" src={slide.captionSrc} default/>
            {/if}
            </video>
          {/if}
          {#if (slide.btnPrev && slide.btnPrev.label) || (slide.btnNext && slide.btnNext.label) }
            <div class="actions">
              {#if slide.btnPrev}
                <button type="button" on:click={ e => requestSlideTransition(slide.id, false) }>{slide.btnPrev.label}</button>
              {/if}
              {#if slide.btnNext}
                <button type="button" on:click={ e => requestSlideTransition(slide.id) }>{slide.btnNext.label}</button>
              {/if}
            </div>
          {/if}
        <!-- {:else if userDidRequestOtherSlide && slide.transitionalContent !== undefined}
          <div class="transitional-content slide-content pov-first-person">
            {@html slide.transitionalContent}
          </div> -->
        <!-- {/if} -->
      </div>
    {/each}
  </div>
</div>

<style>
/* content that's swapped in using @html doesn't get svelte-specific classes... so we have to use :global occasionally */

.deck {
  width: 100%;
  height: 100%;
  position: relative;
}

.slides {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.slide {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

:global(.deck p) { 
  padding: 0 10px; 
  /* text-shadow: 0 0 5px white, 0 0 5px white, 0 0 5px white, 0 0 5px white; */
  margin-bottom: 0;
}

.slide-content {
  text-align: center;
}

button:not(:last-child){
  margin-right: 40px;
}

video.fullscreen-video {
  max-height: 100%;
  max-width: 100%;
}

@media (orientation: portrait){
  
  .slide {
    width: 100vw;
    flex-direction: column;
  }

  .slide-content:not(:last-child)  {
    margin-bottom: 2rem;
  }

  :global(#slide-content:last-child > p) {
    margin-bottom: 0;
  }

  :global(.spacer) {
    height: 0;
  }
}

@media (orientation: landscape){
  .slide {
    width: 100vw;
    flex-direction: row;
  }

  .slide-content:not(last-child) {
    margin-right: 2rem;
  }

  :global(.deck p:not(:first-child)){
    margin-top: 1em;
    margin-bottom: 0;
  }
  
  :global(.deck p:first-child){
    margin-top: 0;
    margin-bottom: 0;
  }

  .actions button {
    margin-bottom: 0;
  }

  .actions button:last-child{
    margin-bottom: 0;
  }

  .actions {
    margin-right: 10px;
  }

  :global(.spacer) {
    height: 5em;
  }
}
</style>

